import React, { Component } from 'react';
import { Grid, Cell, findMatch } from 'react-flexr';
import { createEPIQuery } from '../../utils/epi';
import config from '../config';
import Item from './item';
class Showcase extends Component {
  render() {
    const { heading, list, orderText } = this.props;

    const epi = createEPIQuery(this.props, this.props.addressId);

    if (!list || !list.size) {
      return null;
    }

    return !findMatch('palm') ? (
      <div>
        {heading ? (
          <div style={{ textAlign: 'center' }}>
            <h4 style={{ fontWeight: 'bold' }}>{heading}</h4>
          </div>
        ) : null}

        <Grid>
          {list.slice(0, 3).map(s => (
            <Cell key={s.get('_id') + 'sc'} size="1/3" palm="1/1">
              <Item
                image={
                  s.get('imageUrl') &&
                  `${config.path.images}/${s.get('imageUrl')}`
                }
                link={`/redirect/${s.get('id')}${epi}`}
                orderText={orderText}
              />
            </Cell>
          ))}
        </Grid>
      </div>
    ) : null;
  }
}

export default Showcase;
